import React from 'react'
import { Pencil } from 'components/icons'
import Button from 'components/button'

interface EmbedEditButtonProps {
  label: string
  title: string
  onClick: (anchor: HTMLElement) => void
}

/**
 * The "Edit Dashboard" / "Edit Iframe" button, shown in the embed's bottom-left corner while the pointer
 * is over it in edit mode. Render inside a `relative` container. The embed has pointer events off in
 * edit mode (style.scss), so the button opts back in.
 */
const EmbedEditButton: React.FC<EmbedEditButtonProps> = ({ label, title, onClick }) => (
  <Button
    type="button"
    className="absolute left-2 bottom-2 z-[5] flex pointer-events-auto shadow-[0_2px_6px_rgba(0,0,0,0.18)] hover:border-divider-strong focus:border-divider-strong"
    title={title}
    // Keep the editor's selection, which the dialog edits around.
    onMouseDown={(e) => e.preventDefault()}
    onClick={(e) => onClick(e.currentTarget)}
  >
    <Pencil className="mr-[5px] w-3.5 h-3.5" />
    {label}
  </Button>
)

export default EmbedEditButton
